export const COMPETITION_ID = "-OpCaEMjXEyPHW20f71F";
